import React from "react";
import { getAlleleFrequency } from "../../../../../../../common/helpers/helpers";
import { POPULATIONS_AFFIX } from "../../constants";
import { getFrequencyStyle } from "../../helpers";

export const getRowData = (item, i, suffix, nonpar) => {
  let firstRow = true;
  let rowCounter = 0;
  const rows = [];
  const populationArray = [];

  Object.keys(item).forEach((key) => {
    const itemKey = key.split("_")[2];
    if (itemKey && !populationArray.includes(itemKey)) {
      populationArray.push(itemKey);
      rowCounter += 1;
    }
  });

  POPULATIONS_AFFIX.forEach((obj, j) => {
    const numberVal = item[`an_${suffix}_${obj.affix}`];
    const countVal = item[`ac_${suffix}_${obj.affix}`];
    const homVal = item[`nhomalt_${suffix}_${obj.affix}`];
    const freqStyle = getFrequencyStyle(countVal, numberVal);
    let freqVal;

    if (numberVal && countVal)
      freqVal = getAlleleFrequency(
        countVal / numberVal,
        3,
        freqStyle.color,
        freqStyle.weight
      );

    if (numberVal || countVal || homVal || freqVal) {
      if (obj.affix !== "male" && obj.affix !== "female") {
        const expandedRow = (
          <tr key={`expanded_row_${j}_${i}`}>
            {firstRow && <td rowSpan={rowCounter + 1} />}
            <td className="gnomad-cell">{obj.name}</td>
            <td className="gnomad-cell">
              {countVal ? countVal.toLocaleString().replaceAll(",", " ") : "-"}
            </td>
            <td className="gnomad-cell">
              {numberVal
                ? numberVal.toLocaleString().replaceAll(",", " ")
                : "-"}
            </td>
            <td className="gnomad-cell">
              {homVal ? homVal.toLocaleString().replaceAll(",", " ") : "-"}
            </td>
            {nonpar && <td className="gnomad-cell"> - </td>}
            <td className="gnomad-cell-freq">{freqVal || "-"}</td>
          </tr>
        );

        rows.push(expandedRow);
        firstRow = false;
      }
    }
  });

  const getGenderRow = (affix, label) => {
    const number = item[`an_${suffix}_${affix}`];
    const count = item[`ac_${suffix}_${affix}`];
    const hom = item[`nhomalt_${suffix}_${affix}`];
    const freqStyle = getFrequencyStyle(count, number);
    const alleleFrequency =
      number && count
        ? getAlleleFrequency(
            count / number,
            3,
            freqStyle.color,
            freqStyle.weight
          )
        : null;

    const genderRow = (
      <tr key={`${affix}_expanded_row_${suffix}`}>
        {firstRow && <td rowSpan={rowCounter + 1} />}
        <td className={`gnomad-cell-${affix}`}>{label}</td>
        <td className={`gnomad-cell-${affix}`}>
          {count ? count.toLocaleString().replaceAll(",", " ") : "-"}
        </td>
        <td className={`gnomad-cell-${affix}`}>
          {number ? number.toLocaleString().replaceAll(",", " ") : "-"}
        </td>
        <td className={`gnomad-cell-${affix}`}>
          {hom ? hom.toLocaleString().replaceAll(",", " ") : "-"}
        </td>
        {nonpar === 1 && (
          <td className={`gnomad-cell-${affix}`}>
            {affix === "female" && "-"}
            {affix !== "female" &&
              (count ? count.toLocaleString().replaceAll(",", " ") : "-")}
          </td>
        )}
        <td className={`gnomad-cell-freq-${affix}`}>
          {alleleFrequency || "-"}
        </td>
      </tr>
    );

    rows.push(genderRow);
  };
  if (populationArray.includes("male")) {
    getGenderRow("male", "XY");
    firstRow = false;
  }
  if (populationArray.includes("female")) getGenderRow("female", "YY");

  return rows.length === 0 ? null : rows;
};
